import { useAppDispatch, useAppSelector } from "@/rtkQuery/store";
import {
  toggleCart,
} from "@/rtkQuery/features/services/cartDrawer/cartDrawerSlice";
import {
  selectIsCartOpen,
  selectItemQuantities,
} from "@/rtkQuery/features/services/cartDrawer/cartDrawerSelectors";

export const useCartDrawerPanel = () => {
  const dispatch = useAppDispatch();
  const isCartOpen = useAppSelector(selectIsCartOpen) ?? false;
  const itemQuantities = useAppSelector(selectItemQuantities) ?? {};

  const safeDispatch = (action: any) => {
    if (dispatch) dispatch(action);
  };

  return {
    isCartOpen,
    itemQuantities,
    toggleCart: () => safeDispatch(toggleCart()),
  };
};
